var render, staticRenderFns
import script from "./ac-collection-card.vue?vue&type=script&lang=js&"
export * from "./ac-collection-card.vue?vue&type=script&lang=js&"
import style0 from "./ac-collection-card.vue?vue&type=style&index=0&id=7130d7b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130d7b1",
  null
  
)

export default component.exports